import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import ComplianceOverview from './pages/compliance-overview';
import EmployeeManagement from './pages/employee-management';
import Settings from './pages/settings';
import Login from './pages/login';
import AuditLog from './pages/audit-log';
import ViolationRecords from './pages/violation-records';
import AllViolations from './pages/all-violations';
import PointCreditSystem from './pages/point-credit-system';
import PTOManagement from './pages/pto-management';
import UserManagement from './pages/user-management';
import { AuthProvider } from './contexts/AuthContext';
import WorkOrderTracker from './pages/work-order-tracker';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />

            {/* Protected routes */}
            <Route path="/" element={<ProtectedRoute><ComplianceOverview /></ProtectedRoute>} />
            <Route path="/compliance-overview" element={<ProtectedRoute><ComplianceOverview /></ProtectedRoute>} />
            <Route path="/employee-management" element={<ProtectedRoute><EmployeeManagement /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/audit-log" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/violation-records" element={<ProtectedRoute><ViolationRecords /></ProtectedRoute>} />
            <Route path="/all-violations" element={<ProtectedRoute><AllViolations /></ProtectedRoute>} />
            <Route path="/settings/point-credits" element={<ProtectedRoute><PointCreditSystem /></ProtectedRoute>} />
            <Route path="/pto-management" element={<ProtectedRoute><PTOManagement /></ProtectedRoute>} />
            <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
            <Route path="/work-order-tracker" element={<ProtectedRoute><WorkOrderTracker /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
